import React, { useState, useEffect } from "react";
import ResponsiveAppBar from "@publicPortal/components/responsiveAppBar/ResponsiveAppBar";
import Board from "@publicPortal/components/board/Board";
import TextField from "@mui/material/TextField";
import { UserService } from "@publicPortal/services/UserService";
import getUserCustomProperty from "@shared/mirage/utils/getUserCustomProperty";
import { Stack } from "@mui/system";
import { getInputWidthBasedOnValueLength } from "@mirage/utilities/getInputWidthBasedOnValueLength";
import "./ConsulteeUserSettings.css";
import { IUser, IUserCustomProperties } from "@shared/mirage/core/contracts/IUser";

const ConsulteeUserSettings = () => {
    const userService = new UserService();
    const [customProperties, setCustomProperties] = useState({ consulteeOrganisation: "", consulteePurpose: "" } as IUserCustomProperties);
    const [user, setUser] = useState({ name: "" } as IUser);

    useEffect(() => {
        const getUserData = async () => {
            const user = await userService.getUserById();
            const customProperties = getUserCustomProperty.getUserCustomProperties(user);
            if (user?.id) {
                setUser(user);
                customProperties && setCustomProperties(customProperties);
            }
        };

        getUserData();
    }, []);

    return (
        <>
            <ResponsiveAppBar />
            <Board headerText="Profile Details" size="big">
                <Stack className="fieldsStack">
                    <TextField
                        sx={{ width: getInputWidthBasedOnValueLength(user?.name || "") }}
                        className="fieldsStack__field"
                        id="user-name"
                        label="User Name"
                        variant="outlined"
                        value={user?.name}
                        inputProps={{ className: "fieldsStack__field__input" }}
                        disabled
                    />
                    <TextField
                        sx={{ width: getInputWidthBasedOnValueLength(customProperties?.consulteeOrganisation) }}
                        className="fieldsStack__field"
                        id="user-organisation"
                        value={customProperties?.consulteeOrganisation}
                        label="Organisation"
                        variant="outlined"
                        inputProps={{ className: "fieldsStack__field__input" }}
                        disabled
                    />
                    <TextField
                        sx={{ width: getInputWidthBasedOnValueLength(customProperties?.consulteePurpose) }}
                        className="fieldsStack__field"
                        id="user-purpose"
                        value={customProperties?.consulteePurpose}
                        label="Purpose"
                        variant="outlined"
                        inputProps={{ className: "fieldsStack__field__input" }}
                        disabled
                    />
                </Stack>
            </Board>
        </>
    );
};

export default ConsulteeUserSettings;
